module.exports = __webpack_public_path__ + "static/media/Klink_gaussian2.fe9f9e74.png";